export interface UploadContextState {
    sourceVideoId?: string;
    getSourceVideoId: () => string | undefined;
    setSourceVideoId: (sourceVideoId: string) => void;
    fromWorkflowsUploadModal: boolean;
    setFromWorkflowsUploadModal: (isFromModal: boolean) => void;
}

function uploadContextReducer(set, get): UploadContextState {
    return {
        sourceVideoId: undefined,
        fromWorkflowsUploadModal: false,

        getSourceVideoId() {
            return get().sourceVideoId;
        },
        setSourceVideoId(sourceVideoId: string) {
            return set(() => ({ sourceVideoId }));
        },
        setFromWorkflowsUploadModal(isFromModal: boolean) {
            return set(() => ({ fromWorkflowsUploadModal: isFromModal }));
        }
    };
}

export function buildUploadContextStore(set, get, api) {
    return { ...uploadContextReducer(set, get) };
}
